module.exports = __webpack_public_path__ + "dashboard/img/checkbox_off.4c2e3141a5878eca1a7389649eb2d2bf.svg";